import {leadApiPost} from "./api";

export const postSaveJob = async (postData) => {
  const mainResponse = await leadApiPost(`api/Public/SaveQuote/`, postData);
  console.log("post SaveQuote response", mainResponse);
  return mainResponse
}

export const postScheduleAppointment = async (postData) => {
  const mainResponse = await leadApiPost(`api/Public/Schedule/`, postData);
  console.log("post Schedule response", mainResponse);
  return mainResponse
}
